'use client';

import { c as _c } from "react/compiler-runtime";
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';
import React, { type FC, type ReactNode, useMemo } from 'react';
import '@solana/wallet-adapter-react-ui/styles.css';
import styles from './WalletModalProvider.module.css';
import '@solana-mobile/wallet-standard-mobile';
interface SolanaProviderProps {
  children: ReactNode;
}
export const SolanaProvider: FC<SolanaProviderProps> = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const network = WalletAdapterNetwork.Devnet;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clusterApiUrl(network);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const endpoint = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [new PhantomWalletAdapter({
      network
    })];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const wallets = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      commitment: "confirmed"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <ConnectionProvider endpoint={endpoint} config={t3}><WalletProvider wallets={wallets} autoConnect={true}><WalletModalProvider className={styles.walletModal}>{children}</WalletModalProvider></WalletProvider></ConnectionProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};